import React, { forwardRef, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import {  Animated } from 'react-native';
import { ZoomableViewEvent } from '@openspacelabs/react-native-zoomable-view';
import { useSelector } from 'react-redux';
import { interpolateColor, useSharedValue } from 'react-native-reanimated';
import Svg, { Path } from 'react-native-svg';
export interface LinkProps {
  code: string;
  userGroup: any[];
  sourceUser: String | String[];
  targetUser: String | String[];
  color: string;
  width: number;
}

interface UserLinkHandlerProps {
  zoomProps: ZoomableViewEvent;
  viewWidth: number;
  userList?: any[];
  layout?: { height: number, width: number };
  staticLink?: boolean;
  avatarPressCallback?: (id: string) => void;
  transformFactor?: number;
}

export interface UserLinkHandlerHandle {
  setValues: (values: any) => void;
}
const VIEW_BOX = 3000;
const AnimatedPath = Animated.createAnimatedComponent(Path);
const FlowLinkHandler = forwardRef<UserLinkHandlerHandle, UserLinkHandlerProps>((props, ref) => {
  const [positions, setPositions] = useState([
    { "fullView": undefined, "height": 48.6943790901787, "id": 0, "plotX": 0, "plotY": 0, "width": 74.50238284427996, "x": 74, "y": 528.6528104549107 }]);
  const { userList, staticLink, avatarPressCallback, layout, viewWidth, transformFactor = 0.2 } = props;
  const colorAnim = useRef(new Animated.Value(0)).current;
  const startColor = 'rgb(90,192,234)';
  const endColor = 'rgb(57, 138, 173)';
  const gradientColors = useRef({ start: startColor, mid: startColor, end: startColor });

  const actions = useSelector((state: any) => state.actionMaker.present.actions);
  const [zoomProps, setZoomProps] = useState<ZoomableViewEvent>(props.zoomProps);
  // Effect to update positions whenever links change
  // useEffect(() => {
  //   if (links.length > 0) {
  //     const updatedPositions = links.map(link => ({
  //       id: link.code,
  //       code: link.code,
  //       userGroup: link.userGroup,
  //       plotX: link.sourceUser[0], // Assuming sourceUser contains X, Y coords
  //       plotY: link.sourceUser[1], // Assuming sourceUser contains X, Y coords
  //       width: link.width,
  //     }));
  //     setPositions(updatedPositions);
  //   }
  // }, [links, width]); // Run this effect whenever links prop changes

  useImperativeHandle(ref, () => ({
    setZoomProps(zoomProps) {
      setZoomProps(zoomProps);
    },
    setValues(values) {
      setPositions((positions) => {
        // Check if the user already exists in the positions array
        const userExists = positions.some((position) => position.id === values.id);
        if (!userExists) {
          return [...positions, values];
        }
        return positions.map((position) => {
          if (position.id === values.id) {
            return { ...position, ...values };
          }
          return position;
        });
      });
    },
  }));

  const pulseAnim = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    // startPulsing();
    const listenerId = colorAnim.addListener(({ value }) => {
      gradientColors.current = {
        start: interpolateColor(value, startColor, endColor),
        mid: interpolateColor(value, startColor, endColor),
        end: interpolateColor(value, endColor, startColor),
      };
    });

    return () => {
      pulseAnim.stopAnimation();
      colorAnim.removeListener(listenerId);
    }
  }, [startColor, endColor]);

  return (
    <Svg
      // viewBox={`0 0 ${100} ${100}`}
      style={{ position: "absolute", width: VIEW_BOX, height: 3600, borderWidth: 2 }}
    >
      {actions.length > 0 ? (
        actions.map((position, i) => {
          if (i >= actions.length || !positions[i + 1]) {
            return null;
          }

          const x1 = i === 0 ? VIEW_BOX / 2 + 75 : positions[i].plotX * transformFactor + (VIEW_BOX / 2) + (positions[i].width / 2.3) + 2;
          const y1 = i === 0 ? VIEW_BOX / 2 : (positions[i].plotY * transformFactor) + (VIEW_BOX / 2);
          const x2 = (positions[i + 1].plotX * transformFactor) + (VIEW_BOX / 2) + (positions[i + 1].width / 2.3);
          const y2 = (positions[i + 1].plotY * transformFactor - 18) + (VIEW_BOX / 2.05);

          // Dynamic control points based on relative position
          const cx1 = (x1 + x2) / 2; // Midpoint for a smooth curve
          const cy1 = y1 - 50; // Raise/lower to create curvature
          const cx2 = (x1 + x2) / 2;
          const cy2 = y2 + 50;

          const path = i == 0 ? `M ${x1 - 4} ${y1} 
          C ${cx1} ${cy1 + 50}, ${cx2} ${cy2 - 50}, ${x2} ${y2 + 5}`
            :
            `M ${x1 - 4} ${y1 - 30} 
          C ${cx1 - 2} ${cy1 + 80}, ${cx2} ${cy2 - 80}, ${x2} ${y2}`;


          return (
            <Path
              key={i + "actionlinkpath"} // Important for React list rendering
              d={path}
              fill={"transparent"}
              stroke={gradientColors.current.end}
              strokeDasharray={[10, 2]}
              strokeWidth={3}
              color="lightblue"
            />
          );
        })
      ) : (
        console.log("No positions!"), null
      )}
      {/* <Path transform={[
          {scale: 0.2},
          {translateX: VIEW_BOX},
          {translateY: VIEW_BOX}
        ]} strokeWidth={10} path={startPath || undefined} color="lightblue" /> */}
      {/* {
          actions?.map((link, i) => {
            if (i >= positions.length - 1) {
              console.log("No actions!")
              return null;
            } // Prevent rendering beyond bounds of `positions`
            const buildPath = Skia.Path.MakeFromSVGString(`M ${positions[i].plotX + VIEW_BOX / 2} ${positions[i].plotY + (VIEW_BOX * 1.2) / 2} ${' '} L ${' '} ${positions[i + 1].plotX + VIEW_BOX / 2} ${positions[i + 1].plotY + (VIEW_BOX * 1.2) / 2}`);
            buildPath.stroke();

            console.log('buildPath', buildPath);
            return (

              <Path
                strokeWidth={10}
                path={buildPath || undefined}
                color="lightblue"
              />
            );
          })
        } */}
    </Svg>
  )
});

export default FlowLinkHandler;
